export default __webpack_public_path__ + "static/media/img5.fc7b13ce.png";